// src/hooks/useDebouncedValue.ts
//
// The value as it was `delayMs` after it last changed. Used by the
// relationship pickers so a search request follows a pause in typing rather
// than every keystroke — the same 250–300ms debounce the list pages inline.

import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
